import { createContext, useContext } from "react";
/**
 * Create a side-effect-free context provider.
 */
class BannerContextFactory {
  static Context() {
    return this.context = this.context || /*#__PURE__*/createContext({});
  }
}
BannerContextFactory.context = void 0;
function useBanner() {
  return useContext(BannerContextFactory.Context());
}
export { BannerContextFactory, useBanner };